import {
  FETCH_START,
  FETCH_SUCCESS,
  FETCH_ERROR,
  SHOW_MESSAGE,
  GET_VIDEO_CATEGORIES,
} from '../../shared/constants/ActionTypes';
import jwtAxios from '@crema/services/auth/jwt-auth/jwt-api';

/** Let the client set multipart boundary (do not force application/json). */
const multipartFormConfig = {
  transformRequest: [
    (data, headers) => {
      if (data instanceof FormData) {
        delete headers['Content-Type'];
      }
      return data;
    },
  ],
};

const isApiSuccess = (res) => {
  if (res.status !== 200) {
    return false;
  }
  const d = res.data;
  if (d == null || typeof d !== 'object') {
    return true;
  }
  if ('status' in d) {
    return d.status === true;
  }
  if ('succeeded' in d) {
    return d.succeeded === true;
  }
  return true;
};

const getCategoryId = (item) => {
  if (!item || typeof item !== 'object') {
    return undefined;
  }
  const raw =
    item.id ??
    item.Id ??
    item.videocategoryId ??
    item.videoCategoryId ??
    item.VideoCategoryId;
  if (raw == null || raw === '') {
    return undefined;
  }
  return String(raw);
};

const normalizeCategoryRow = (item) => {
  const id = getCategoryId(item);
  return {
    ...item,
    id,
    title: item.title ?? item.Title ?? '',
    description: item.description ?? item.Description ?? '',
    image:
      item.image ??
      item.Image ??
      item.imageName ??
      item.ImageName ??
      item.imageUrl ??
      item.thumbnailUrl ??
      '',
    order: Number(item.order ?? item.Order ?? 0),
    isActive: Boolean(item.isActive ?? item.IsActive ?? false),
  };
};

const parseListPayload = (payload) => {
  if (Array.isArray(payload)) {
    return {list: payload, total: payload.length};
  }
  if (payload && Array.isArray(payload.data)) {
    return {
      list: payload.data,
      total:
        typeof payload.total === 'number'
          ? payload.total
          : payload.data.length,
    };
  }
  return {list: [], total: 0};
};

export const getVideoCategories = () => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    jwtAxios
      .get('/videocategory')
      .then((res) => {
        if (!isApiSuccess(res)) {
          dispatch({
            type: FETCH_ERROR,
            payload:
              res.data?.message ||
              res.data?.error ||
              'Something went wrong, Please try again!',
          });
          return;
        }
        dispatch({type: FETCH_SUCCESS});
        const {list, total} = parseListPayload(res.data);
        dispatch({
          type: GET_VIDEO_CATEGORIES,
          payload: {
            categories: list.map(normalizeCategoryRow),
            total,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload:
            error?.response?.data?.message ??
            error?.response?.data?.error ??
            error?.response?.data?.msg ??
            error?.message,
        });
      });
  };
};

export const addVideoCategory = (formData, onDone) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    jwtAxios
      .post('/videocategory', formData, multipartFormConfig)
      .then((res) => {
        if (isApiSuccess(res)) {
          dispatch({type: FETCH_SUCCESS});
          if (res.data?.message) {
            dispatch({type: SHOW_MESSAGE, payload: res.data.message});
          }
          dispatch(getVideoCategories());
          onDone?.();
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload:
              res.data?.message ||
              res.data?.error ||
              'Something went wrong, Please try again!',
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload:
            error?.response?.data?.message ??
            error?.response?.data?.error ??
            error?.message,
        });
      });
  };
};

/** PUT multipart: include `Image` only when replacing; server keeps existing image if omitted. */
export const updateVideoCategory = (videocategoryId, formData, onDone) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    jwtAxios
      .put('/videocategory', formData, {
        ...multipartFormConfig,
        params: {videocategoryId},
      })
      .then((res) => {
        if (isApiSuccess(res)) {
          dispatch({type: FETCH_SUCCESS});
          if (res.data?.message) {
            dispatch({type: SHOW_MESSAGE, payload: res.data.message});
          }
          dispatch(getVideoCategories());
          onDone?.();
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload:
              res.data?.message ||
              res.data?.error ||
              'Something went wrong, Please try again!',
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload:
            error?.response?.data?.message ??
            error?.response?.data?.error ??
            error?.message,
        });
      });
  };
};

export const deleteVideoCategory = (videocategoryId) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    jwtAxios
      .delete(`/videocategory/${videocategoryId}`)
      .then((res) => {
        if (isApiSuccess(res)) {
          dispatch({type: FETCH_SUCCESS});
          if (res.data?.message) {
            dispatch({type: SHOW_MESSAGE, payload: res.data.message});
          }
          dispatch(getVideoCategories());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload:
              res.data?.message ||
              res.data?.error ||
              'Something went wrong, Please try again!',
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload:
            error?.response?.data?.message ??
            error?.response?.data?.error ??
            error?.message,
        });
      });
  };
};
